import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import ReportsScreen from '../../screens/Reports/ReportsScreen.jsx';
import { loadOSForReport, isOSInDateRange } from '../../core/utils/osReport';

const ReportsContainer = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getDefaultFilter = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    return {
      dates: [firstDay, lastDay],
    };
  };

  const [filter, setFilter] = useState(getDefaultFilter());
  const company = useSelector((state) => state.app.company || {});
  const user = useSelector((state) => state.app.user || {});

  useEffect(() => {
    loadData();
  }, [company.id]);

  const loadData = async () => {
    if (!company.id) return;

    setIsLoading(true);
    try {
      const rows = await loadOSForReport(company.id);
      setData(rows);
    } catch (error) {
      console.error('Erro ao carregar relatórios:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ReportsScreen
      data={filteredData(data, filter)}
      company={company}
      user={user}
      filter={filter}
      setFilter={setFilter}
      isLoading={isLoading}
    />
  );
};

export default ReportsContainer;

const filteredData = (data, filter) => {
  return data.filter((item) => doFilter(item, filter));
};

const doFilter = (item, filter) => {
  let isSearch = true;
  if (filter && filter.search) {
    isSearch =
      item?.code?.toLowerCase().includes(filter.search.toLowerCase()) ||
      item?.vehicle?.toLowerCase().includes(filter.search.toLowerCase());
  }

  let isDates = true;
  if (filter && filter.dates && filter.dates[0] && filter.dates[1]) {
    isDates = isOSInDateRange(item, filter.dates[0], filter.dates[1]);
  }

  let isStatus = true;
  if (filter && filter.status && filter.status.value) {
    isStatus = item.status === filter.status.value;
  }

  return isSearch && isDates && isStatus;
};
